export enum PaymentType {
  RECURRING = 'Recurring',
  ONE_TIME = 'One Time',
}
